<template>
  <div class="container report">
    <div class="searchCondition">
			<el-date-picker size="mini" v-model="where.date" type="date" editable:="false" value-format="yyyy-MM-dd" />
      <el-input
        v-model="where.offer_id"
        style="width: 300px"
        placeholder="Offer"
        clearable
		size="mini"
      ></el-input>
      <el-button size="mini" @click="search">Search</el-button>
      <exportcsv :rows="rows" filename="OfferPayment" :tableObj="$refs.table"></exportcsv>
    </div>
    <el-table
      :data="rows"
      height="250"
      border
      stripe
      class="table"
      v-loading="loading"
      header-row-class-name="table-header"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      ref="table"
    >
      <el-table-column label="Date" prop="date"/>
      <el-table-column label="ChannelId" prop="channel_id"/>
			<el-table-column label="Channel" prop="channel_name"/>
      <el-table-column label="Offer Id" prop="offer_id" />
			<el-table-column label="Offer Name" prop="offer_name"/>
			<el-table-column label="Count" prop="count"/>
    </el-table>
    <el-pagination
      style="margin-left: 30px"
      layout="total,sizes,prev, pager, next"
      :total="total"
      :current-page.sync="page"
      @current-change="search"
      :page-size.sync="limit"
      @size-change="search"
      :page-sizes="[20,50,200]"
    >
    </el-pagination>
  </div>
</template>
<script>
import { post } from "@/lib/channelClient";
import exportcsv from '@/components/channelClient/exportcsv.vue';

export default {
	components:{
		exportcsv,
	},
	data() {
		return {
			where: {
				date: new Date().toISOString().substr(0,10),
				offer_id: "",
			},
			rows: [],
			total: 0,
			limit: 20,
			page: 1,
			revenueTotal: 0,
			loading: false,
		};
	},
	mounted() {
		this.search();
	},
	methods: {
		async search() {
			await new Promise((res) => setTimeout(res, 0));
			const where = this.where;
			const limit = this.limit;
			const offset = (this.page - 1) * limit;
			this.loading = true;
			const res = await post("/channelClient/implog", {
				where,
				limit,
				offset,
			});
			this.loading = false;
			if (res.status != 200) {
				const text = await res.text();
				if (/login/.test(text)) {
					window.location.href = "/login";
					return;
				}
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			this.rows = body.rows;
			this.total = body.count;
		},
		// async pageChange(page) {
		// 	this.page = page;
		// 	await this.search();
		// },
		// async	pageSizeChange(pageSize) {
		// 	this.pageSize = pageSize;
		// 	await this.refresh();
		// }
	},
};
</script>
<style scoped>


</style>
